export const bedrooms = [0, 1, 2, 3]
export const bathrooms = [0, 1]

export const aspect = ["N", "E", "S", "W"]
